import { useMemo } from 'react';
import { isTeacherApp } from '@punchcard/core/utils';

/**
 * Custom hook for handling app-specific assessment logic
 * Separates app type detection from UI rendering logic
 */
export const useAssessmentAppLogic = () => {
	const isTeacher = useMemo(() => isTeacherApp, []);

	/**
	 * Determines if assessment attempts should be displayed
	 */
	const shouldShowAttempts = useMemo(() => isTeacher, [isTeacher]);

	/**
	 * Type guard for TeacherCourseActivityDTO
	 */
	const isTeacherCourseActivity = (
		activity: StudentCourseActivityDTO | TeacherCourseActivityDTO
	): activity is TeacherCourseActivityDTO => {
		return isTeacher && 'assessmentAttempts' in activity;
	};

	/**
	 * Checks if an activity has attempts to display
	 */
	const hasAttemptsToShow = (activity: StudentCourseActivityDTO | TeacherCourseActivityDTO): boolean => {
		return isTeacherCourseActivity(activity) && Boolean(activity.assessmentAttempts?.length);
	};

	return {
		isTeacher,
		shouldShowAttempts,
		isTeacherCourseActivity,
		hasAttemptsToShow
	};
};
